import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { LangProvider } from "@/context/LangContext";
import SmoothScroll from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { ChatWidget } from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import ProductDetail from "@/pages/ProductDetail";
import Services from "@/pages/Services";
import Formations from "@/pages/Formations";
import FormationDetail from "@/pages/FormationDetail";
import Contact from "@/pages/Contact";
import Conseils from "@/pages/Conseils";
import Equipe from "@/pages/Equipe";
import EspaceClient from "@/pages/EspaceClient";
import International from "@/pages/International";
import References from "@/pages/References";
import ResetPassword from "@/pages/ResetPassword";
import ArticleDetail from "@/pages/ArticleDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SuiviDevis from "@/pages/SuiviDevis";
import InclusionHandicap from "@/pages/InclusionHandicap";
import ComparateurEthylotests from "@/pages/ComparateurEthylotests";
import ComparateurExosquelettes from "@/pages/ComparateurExosquelettes";
import Faq from "@/pages/Faq";
import NotFound from "@/pages/NotFound";

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <CartDrawer />
      <ChatWidget />
    </>
  );
}

function Shell() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const content = (
    <Routes>
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/catalogue" element={<PublicLayout><Catalogue /></PublicLayout>} />
      <Route path="/catalogue/:id" element={<PublicLayout><ProductDetail /></PublicLayout>} />
      <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
      <Route path="/formations" element={<PublicLayout><Formations /></PublicLayout>} />
      <Route path="/formations/:id" element={<PublicLayout><FormationDetail /></PublicLayout>} />
      <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
      <Route path="/equipe" element={<PublicLayout><Equipe /></PublicLayout>} />
      <Route path="/espace-client" element={<PublicLayout><EspaceClient /></PublicLayout>} />
      <Route path="/reset-password" element={<PublicLayout><ResetPassword /></PublicLayout>} />
      <Route path="/international" element={<PublicLayout><International /></PublicLayout>} />
      <Route path="/references" element={<PublicLayout><References /></PublicLayout>} />
      <Route path="/suivi-devis" element={<PublicLayout><SuiviDevis /></PublicLayout>} />
      <Route path="/inclusion-handicap" element={<PublicLayout><InclusionHandicap /></PublicLayout>} />
      <Route path="/comparateur-ethylotests" element={<PublicLayout><ComparateurEthylotests /></PublicLayout>} />
      <Route path="/comparateur-exosquelettes" element={<PublicLayout><ComparateurExosquelettes /></PublicLayout>} />
      <Route path="/faq" element={<PublicLayout><Faq /></PublicLayout>} />
      <Route path="/conseils" element={<PublicLayout><Conseils /></PublicLayout>} />
      <Route path="/conseils/:slug" element={<PublicLayout><ArticleDetail /></PublicLayout>} />
      <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
      <Route path="/payment/cancel" element={<PublicLayout><PaymentCancel /></PublicLayout>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
    </Routes>
  );
  return isAdmin ? content : <SmoothScroll>{content}</SmoothScroll>;
}

function App() {
  return (
    <div className="grain" style={{ overflowX: "hidden" }}>
      <AuthProvider>
        <LangProvider>
          <CartProvider>
            <BrowserRouter>
              <Shell />
            </BrowserRouter>
          </CartProvider>
        </LangProvider>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
